module.exports = __webpack_public_path__ + "static/media/NP.ddc9a140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NP.svg
// module id = 332
// module chunks = 0